import { address_server_short, API_V2 } from '../config';
import { error } from '../utils/handlerError';
import { axiosInstance } from './common/axios.instance';

const SCHEMES = 'schemes';

export async function getAllSchemes({ search, sorting } = {}) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}`, {
    withCredentials: true,
    params: {
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getAllSchemes', data);
}

export async function createScheme(scheme) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}`, {
    withCredentials: true,
    method: 'POST',
    data: {
      ...scheme,
    },
  });

  if (!data.success) {
    error('createScheme', data);
  }

  return data;
}

export async function updateScheme(scheme) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}/${scheme.id}`, {
    withCredentials: true,
    method: 'PATCH',
    data: {
      name: scheme.name,
    },
  });

  if (!data.success) {
    error('updateScheme', data);
  }

  return data;
}

export async function deleteScheme(id) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}/${id}`, {
    withCredentials: true,
    method: 'DELETE',
  });

  if (!data.success) {
    error('deleteScheme', data);
  }

  return data;
}

export async function getSchemeById(id) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}/${id}`, {
    withCredentials: true,
  });

  if (data.success) {
    if (data.result) return data.result;
    return {};
  }
  error('getSchemeById', data);
}

export async function createSchemeNode(node) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}/nodes`, {
    withCredentials: true,
    method: 'POST',
    data: {
      id_scheme: node.id_scheme,
      id_parent: node.id_parent,
      id_protocol: node.id_protocol,
      type: node.type,
      objects: node.objects,
      resources: node.resources,
    },
  });

  if (!data.success) {
    error('createSchemeNode', data);
  }

  return data;
}
export async function updateSchemeNode(id, node) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}/nodes/${id}`, {
    withCredentials: true,
    method: 'PUT',
    data: {
      id_scheme: node.id_scheme,
      id_parent: node.id_parent,
      id_protocol: node.id_protocol,
      id_quality: node.id_quality,
      type: node.type,
      objects: node.objects,
      resources: node.resources,
    },
  });

  if (!data.success) {
    error('updateScheme', data);
  }

  return data;
}

export async function deleteSchemeNode(id) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${SCHEMES}/nodes/${id}`, {
    withCredentials: true,
    method: 'DELETE',
  });

  if (!data.success) {
    error('deleteSchemeNode', data);
  }

  return data;
}
